module.exports = __webpack_public_path__ + "public/images/membership_promo_mobile.00ea17d9c20311f50f99d91d9fe3d4e3.png";